import { render, staticRenderFns } from "./ArtistElements.vue?vue&type=template&id=4719ced4&scoped=true&"
import script from "./ArtistElements.vue?vue&type=script&lang=js&"
export * from "./ArtistElements.vue?vue&type=script&lang=js&"
import style0 from "./ArtistElements.vue?vue&type=style&index=0&id=4719ced4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4719ced4",
  null
  
)

export default component.exports